import { render, staticRenderFns } from "./guaranteeFact.vue?vue&type=template&id=56335c02"
import script from "./guaranteeFact.vue?vue&type=script&lang=js"
export * from "./guaranteeFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports